export function isValidDate(date: string): boolean {
	return typeof date === 'string' && new Date(date).toString() !== 'Invalid Date';
}
